<template>
  <div id="box" v-loading="loading">
    <!-- 头部组件 -->
    <header class="box">
      <headers :type="'blue'"></headers>
    </header>
    <div class="home">
      <div class="content flex">
        <div class="left">
          <div class="tab_title">版权金融</div>
          <!-- <div class="tab_title" v-if="this.id == '2'">口述著作权登记指南</div>
          <div class="tab_title" v-if="this.id == '3'">音乐著作权登记指南</div>
          <div class="tab_title" v-if="this.id == '4'">戏剧著作权登记指南</div>
          <div class="tab_title" v-if="this.id == '5'">曲艺著作权登记指南</div>
          <div class="tab_title" v-if="this.id == '6'">舞蹈著作权登记指南</div>
          <div class="tab_title" v-if="this.id == '7'">杂技著作权登记指南</div>
          <div class="tab_title" v-if="this.id == '8'">美术著作权登记指南</div>
          <div class="tab_title" v-if="this.id == '9'">建筑著作权登记指南</div> -->

          <div
            :title="i.typeName"
            class="tab_item"
            v-for="i in sidebarList"
            :key="i.id"
            :class="curId == i.id ? 'active' : ''"
            @click="changePage(i.id)"
          >
            <div class="text-hidden">{{ i.typeName }}</div>
            <i class="icon-youjiantou iconfont"></i>
          </div>
          <!-- <div class='tab_item' :class='page == "flow"?"active":""' @click="changePage('flow')">申请流程 <i class='icon-youjiantou iconfont'></i></div> -->
          <!-- <div class='tab_item' :class='page == "materials"?"active":""' @click="changePage('materials')">所需材料 <i class='icon-youjiantou iconfont'></i></div> -->
          <!-- <div class='tab_item' :class='page == "chargestandard"?"active":""' @click="changePage('chargestandard')">收费标准 <i class='icon-youjiantou iconfont'></i></div> -->
          <!-- <div class='tab_item' :class='page == "fillexplain"?"active":""' @click="changePage('fillexplain')">填表说明 <i class='icon-youjiantou iconfont'></i></div> -->
          <!-- <div class='tab_item' :class='page == "myfill"?"active":""' @click="changePage('myfill')">我要填表 <i class='icon-youjiantou iconfont'></i></div> -->
          <!-- <div class='tab_item' :class='page == "scheduleinquire"?"active":""' @click="changePage('scheduleinquire')">进度查询 <i class='icon-youjiantou iconfont'></i></div> -->
          <!-- <div class='tab_item' :class='page == "issue"?"active":""' @click="changePage('issue')">常见问题 <i class='icon-youjiantou iconfont'></i></div> -->
        </div>
        <div class="right">
          
          <div class="user_box second_box">
            <template v-if="step=='1'">
                <div
                  class="user_title second_title "
                  style="font-size: 20px;line-height:3;"
                  
                  @click="secondCilck(index)"
                  v-for="(i, index) in options"
                  :key="index"
                >
                 <div class="text-hidden">{{ i.financeType }}</div>
                  <span class="el-icon-arrow-right" style="font-size: 20px;font-weight:600"></span>
                </div>
            </template>
          </div>
            
            
          <!-- <applicants v-if="page == 'applicants'"></applicants>
          <flow v-if="page == 'flow'"></flow> 
          <materials v-if="page == 'materials'"></materials>
          <chargestandard v-if="page == 'chargestandard' "></chargestandard>
          <fillexplain v-if="page == 'fillexplain' "></fillexplain>
          <myfill v-if="page == 'myfill'"></myfill>
          <scheduleinquire v-if="page == 'scheduleinquire'"></scheduleinquire>
          <issue v-if="page == 'issue'"></issue> -->
          <div class="user_box" v-if="step=='2'">
            
            <div class="boxss" v-for="(i,index) in options" :key="i.ruleType" >
               
              <div class="cont" v-if="curIndex == index">
                <!-- <div @click.stop="backList" class="back-list" style="font-size: 18px;line-height: 2;"><span class="el-icon-arrow-left" style="font-size: 18px;font-weight:600"></span> 返回</div> -->
                <div class="user_title">{{ i.financeType }}</div>
                <div class="html" v-html="i.financeContent">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 尾部组件 -->
    <div class="box box1">
      <tails></tails>
    </div>
  </div>
</template>

<script>
import headers from "@/components/header";
import tails from "@/components/tail";
import applicants from "@/view/help_center/applicants";
import flow from "@/view/help_center/flow";
import materials from "@/view/help_center/materials";
import chargestandard from "@/view/help_center/chargestandard";
import fillexplain from "@/view/help_center/fillexplain";
import myfill from "@/view/help_center/myfill";
import scheduleinquire from "@/view/help_center/scheduleinquire";
import issue from "@/view/help_center/issue";
export default {
  data() {
    return {
      page: "applicants",
      data: "",
      loading: false,
      id: "",
      datas: "",
      sty: "",
      value: "选项1",
      step: "1",
      options: [],
      curIndex: 0,
      curId:'',
      sidebarList:[]
    };
  },
  components: {
    headers,
    tails,
    applicants,
    flow,
    materials,
    chargestandard,
    fillexplain,
    myfill,
    scheduleinquire,
    issue,
  },
  created() {
    this.id = this.$route.query.id;
    this.acting();
  },
  methods: {
    backList() {
      this.step = "1";
    },
    secondCilck(index) {
      this.curIndex = index;
      this.step = "2";
    },

    acting() {
        this.loading=true
      this.$getHttp("/pc/CopyrightFinanceType/getTypeList").then((res) => {
        // this.agreementas = res.r[0].content;
        // console.log(res.r,"11111111111")
        this.sidebarList = res.data;
        //         ruleContent: "<p>yufhjjgjghgjhgjgjhgjhgj</p>"
        // ruleType:
        // this.loading = false;
        if(res.data.length>0){
            this.curId = res.data[0].id;
             this.$getHttp("/pc/CopyrightFinance/findAllList",{type:this.curId}).then((data)=>{
                this.options =data.data
                 this.loading=false
             })
        }
        
      }).catch((err)=>{
              this.loading=false
             });
    },
    changePage(page) {
    //   this.step = "1";
    //   this.page = page;
    //   this.curId = page;
this.loading=true
      this.$getHttp("/pc/CopyrightFinance/findAllList",{type:page}).then((data)=>{
                this.options =data.data
                this.step = "1";
                  this.curId = page;
                   this.loading=false
             }).catch((err)=>{
              this.loading=false
             })
    },
  },
};
</script>

<style lang='less' scoped>
.displayno {
  display: none;
}
.displayb {
  display: block;
}
.back-list {
  cursor: pointer;
  color: #333333;
  font-size: 24px;
}
.second_box {
  box-sizing: border-box;
  padding: 50px 100px;
  
}
.second_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  cursor: pointer;
  color: #333 !important;
  &.active{
     color:#0068b7!important;
  }
}

.selectTitle {
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 48px;
  // z-index: 1;
  padding: 0 100px;
}
.user_box {
  //   top: 50px !important;
  z-index: 2;
   color: #333333;

}
.boxss .cont {
  //   padding-top: 0px !important;
}
.text-hidden {
  width: 666px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.boxss {
  .cont {
    padding: 50px 100px;
  }
  .html {
    margin-top: 20px;
    color: #000;
  }
}
.user_box {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  background: #fff;
  overflow: auto;
  .user_title {
    color: #0068b7;
    font-size: 28px;
    // height: 56px;
  }
  .user_info {
    margin-top: 50px;
    margin-left: 122px;
    .info_item {
      display: flex;
      position: relative;
      margin-bottom: 40px;
      .info_item_left {
        width: 161px;
        font-size: 22px;
        height: 28px;
        line-height: 28px;
        color: #666666;
      }
      .info_item_right {
        font-size: 20px;

        height: 28px;
        line-height: 28px;
        color: #333333;
      }
      .icon1 {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
      .modify {
        position: absolute;
        left: 531px;
        color: #0068b7;
        height: 28px;
        font-size: 20px;

        font-weight: 400;
        line-height: 28px;
        color: #0068b7;
        opacity: 1;
      }
    }
  }
}
.avatar-uploader {
  width: 480px;
  height: 260px;
  background: #ffffff;
  border: 1px solid #d0d0d0;
  opacity: 1;
  border-radius: 10px;
  margin-bottom: 20px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
#avatar1 .el-upload--text,
#avatar .el-upload--text {
  margin: 0;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 480px;
  height: 260px;
  line-height: 260px;
  text-align: center;
}
.avatar {
  width: 200px;
  height: 200px;
  display: block;
}
.user_box::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
  display: none;
}
.user_box::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ebebeb;
}
.user_box::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
  border-radius: 10px;
  background: #fff;
}
#box {
  // position: absolute;
  // // left: 0;
  // // top: 0;
  // width: 100%;
  // height: 100%;
  background: #f3f6f8;
  //   min-width: 1440px;
}
.box {
  background: #0068b7;
}
.box1 {
  background: #f2f2f2;
}
.home {
  height: calc(100% - 243px);
  min-height: 690px;
  background-color: #f3f6f8;
  overflow: auto;
  width: 1200px;
  display: block;
  margin: 0 auto;
  .content {
    height: 100%;
    background-color: #fff;
  }
  .left {
    width: 300px;
    min-height: 690px;
    background-color: #dee8f8;
    .tab_title {
      color: #333333;
      height: 37px;
      font-size: 20px;

      line-height: 37px;
      color: #333333;
      opacity: 1;
      margin: 40px 0 13px 20px;
    }
    .tab_item {
      height: 54px;
      line-height: 54px;
      color: #333;
      display: flex;

      font-size: 18px;
      opacity: 1;
      text-indent: 60px;
      position: relative;
      transition: all 0.5s;
      cursor: pointer;
      .iconfont {
        position: absolute;
        top: 50%;
        right: 20px;
        font-size: 20px;
        transform: translateY(-50%);
      }
    }
    .tab_item:hover {
      color: #0068b7;
      background: #fff;
      transition: all 0.5s;
    }
    .active {
      color: #0068b7;
      background: #fff;
    }
  }
  .right {
    width: 980px;
    min-height: 100%;
    position: relative;
    .iframe {
      width: 100%;
      height: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/V2/finance.vue